"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlWithProtocol = void 0;
const getUrlWithProtocol = function (url) {
  let protocol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https';
  if (typeof url !== 'string' || url.includes('://')) {
    return url;
  }
  return `${protocol}://${url}`;
};
exports.getUrlWithProtocol = getUrlWithProtocol;